import { render, staticRenderFns } from "./ClassStartDialog.vue?vue&type=template&id=36db8700"
import script from "./ClassStartDialog.vue?vue&type=script&lang=js"
export * from "./ClassStartDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports